import { IUserPreferences } from '@shared/interfaces/IUserPreferences';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { entitiesApi } from '@src/servicesInitializer';
// eslint-disable-next-line import/no-cycle
import { setUserPreferences } from '../slices/userPreferences.slice';

// Self-scoped: the server resolves the user from the token, so no username
// travels in the URL. Passing one was what let any caller read or overwrite
// anybody else's preferences.
export const updateUserPreferences = (userPreferences: Partial<IUserPreferences>) => async (dispatch) => {
	const updatedUserPreferences: IUserPreferences = await entitiesApi.userPreferences.updateOwnUserPreferences({
		body: userPreferences,
	});
	dispatch(setUserPreferences({ userPreferences: updatedUserPreferences }));
};

export const getUserPreferences = createAsyncThunk('getUserPreferences', async () => {
	const userPreferences: IUserPreferences | null = await entitiesApi.userPreferences.getOwnUserPreferences();

	return { userPreferences: userPreferences || null };
});
